import styled from "styled-components";
export const StyledApprovalList = styled.div`
  div.tma__table-container {
    height: 71vh;
    margin-top: 1rem;
    .ag-header-cell-label {
      font-size: 12px;
    }
  }
  .tma_approval_header {
    display: flex;
    align-items: center;
    .tma_header_approval__actions {
      display: flex;
      margin-left: auto;
      alig-items: center;
      gap: 0.5rem;
      .tma_popup_btn {
        height: 40px;
        top: 5px;
      }
      button.tma_popup_btn:disabled {
        background-color: var(--input-disabled-color);
        color: grey;
        cursor: not-allowed;
      }
      .week-picker-display {
        margin-left: auto;
      }
    }
  }
  .ag-center-cols-container {
    width: 100% !important;
  }
`;
export const StyledApprovalContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 0rem;
  position: relative;
  button.tma_popup_btn {
    min-width: unset !important;
    font-size: 12px;
    padding: 0;
    background-color: transparent !important;
    color: var(--secondary-btn-text) !important;
    span.tma_btn_custom_icon {
      top: 0px;
      display: flex;
    }
    svg {
      fill: var(--primary-text);
    }
  }
  .tma_approval-edit span.tma_status {
    text-transform: capitalize;
    border-radius: 100%;
    border: 0px solid;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      padding: 0px;
      cursor: auto;
      svg {
        fill: white;
      }
    }
  }
  span.tma_status_accepted,
  span.tma_status_approved {
    // background: radial-gradient(circle, #31af36 -100%, transparent 65%);
    border-color: #31af36;
    // background-color: #31af36;
    button {
      svg {
        fill: #31af36;
      }
    }
  }
  span.tma_status_rejected {
    // background: radial-gradient(circle, #ff0000 -100%, transparent 65%);
    border-color: #ff0000;
    // background-color: #ff0000;
    button {
      svg {
        fill: #ff0000;
      }
    }
  }
  span.tma_status_pending {
    // background: radial-gradient(circle, #ff9800 -100%, transparent 65%);
    border-color: #ff9800;
    // background-color: #ff9800;
    button {
      svg {
        fill: #ff9800;
      }
    }
  }
  &.tma_read_action {
    button.tma_popup_btn {
      visibility: hidden;
      display: none;
    }
  }
`;
export const StyledTimesheetContainer = styled.section`
padding-bottom:1rem;
header.tma_timesheet_header
{
    .tma_primary_row{
        h1{
            font-size:24px;
        }
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .tma_submit_actions{
            display:flex;
            gap:0.45rem;
            align-items:center;
            flex-wrap: wrap;
            button{
                border-radius:5px;
            }
            .week-picker-display
            {
                box-shadow: none;
                border: 1px solid #ddd;
                border-radius: 0;
                padding: 0;
                scale: none;
                height: 41px;
                div.selected-week-display {
                    margin: 0;
                    .arrow-container {
                        width: 40px;
                        height: 40px;
                        border-radius: 0;
                        background: var(--primary-text);
                        svg {fill: #fff; stroke: #fff; width: 16px; height: 16px;}
                    }
                }
                    div.selected-week-indicator{gap: 0;}
            }
            }
            button.tma_popup_btn
            {
                background-color:var(--route-active-bg);
                color: var(--route-active-text);
                display: flex;
                align-items: center;
            }
                button {
                height: 40px;
                  &.tma_time_submit_btn {
                    background-color: var(--success)
                  }
                    &.tma_time_draft_btn {
                      border-color: var(--primary-text);
                      color: var(--primary-text);
                      &:hover {
                        background-color: var(--primary-text);
                        color: white;
                      }
                    }
                }
        }
    }
    .tma_secondary_row{
        display: flex;
        justify-content: end;
        margin-top: 1rem;
        .tma_submit_actions
        {
            display: flex;
            gap: 1rem;
            align-items: center;
            button{
                height:34px;
            }
        }
    }
 &.tma__timsheet_approval_header{
   .tma_submit_actions{
    button.tma_time_reject_btn{
        width:120px;
        background: #fff;
        span {margin: 0; &.tma_btn_text {padding-right: 5px;} &.tma_btn_custom_icon svg {width: 20px;}}
    }
    button.tma_time_arrove_btn{
      width:120px;
      span {margin: 0; &.tma_btn_text {padding-right: 5px;} &.tma_btn_custom_icon svg {width: 20px;}}
  }
    button.tma_time_arrove_btn {
        background-color: var(--success);
        transition: all 0.5s ease-in-out;
        &:hover {
          background-color: var(--success-hover);
        }
    }
   }
 }
}
section.tma_time_entry_container
{
    background-color: white;
    position: relative;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 1rem;
    border-radius: 5px;
    button.tima_time_editoff-button{
     position: absolute;
     top: 8px;
     right: 8px;
     background-color: transparent;
     border: none;
     padding: 1rem;
     font-weight: bold;
     cursor: pointer;
     color: var(--primary-button-bg);
    }
    
}
section.tma_proj_details
{    
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .tma_prj_info_container
    {
        display:flex;
        p.tma_pnf_label
        {
            flex: 0 0 120px;
            max-width: 120px;
            color:var(--label-text);
        }
    }
    .tma_copy_previous
    {
        width:25%;
        margin-left:auto;
        button{
            text-transform:none;
            text-decoration:underline;
            font-size:12px;
        }
    }
}
section.tma_time_entry
{
    font-size:12px;
    button.tma_add_new_row
    {
        height:26px;
        margin-top:0.75rem;
        text-transform:none;
        border-radius:5px;
    }
    .tma_approver_cmnts{
        font-size:14px;
        margin:1rem auto;
        span.tma_label{
            color:var(--label-text);
        }
        span.tma_value{
            color:#333;
            font-weight:bold;
            margin-left:0.75rem;
        }
    }
    .tma_comment_box
    {
        margin:1rem auto;
        textarea{
            resize:none;
            border:1px solid var(--input-border-color);
            padding:0.5rem;
            border-radius:5px;
        }
    }
    hr {
      width: 100%;
    }
    .tma_time_total_hours
    {
          display: flex;
          justify-content: flex-start;
          margin-top: 1rem;
          margin-left: 0;
          width: 1360px;
          padding-bottom: 1rem;
        .tma_col_count{
            display: flex;
            justify-content: space-around;
            margin-left: auto;
            flex-basis: 47%;
            font-size:13.3px;
        }
    }
    .tma_timesheet_note{
        margin-left: auto;
        width: 27%;
        margin-top: 1.5rem;
        font-size: 12px;
    }
}
div.tma_entry_sheet_info
{
    display:flex;
    margin-top:1rem;
    justify-content: space-between;
    align-items:baseline;
    .tma_task_headers,.tma_day_labels
    {
        display:flex;
        gap:1rem;
    }
    .tma_task_headers{
        flex-direction:column;
        gap:0;
        .empty-row{
            visibility:hidden;
        }
        .task_headers_item_labels
        {
            display:flex;
            justify-content: space-around;
            margin-left: 1.5rem;
            .tma_drpdwn_action_row
            {
                text-align: left;
                flex-basis: 190px;
                label{
                white-space:nowrap;
                font-size:12px;
                color:var(--label-text);
                span.tma_label_required
                {
                    color:red;
                    margin-left:0.25rem;
                }
            }
            }
        }
        .tma_prj_action_items
        {
            display:flex;
            flex-direction: column;
            margin-top:0.10rem;
        }
        .tma_task_prj_lables{
            display:flex;
            gap:1rem;
        }
        .tma_drpdwn-row {
            display:flex;
            gap:0.5rem;
            align-items:end;
            label{
                span.tma_label_required
                {
                    color:red;
                    margin-left:0.25rem;
                }
            }
            .tma_delete_row
            {
                position: relative;
                svg{
                    width:20px;
                    cursor:pointer;
                }
            }
            .tma__dropdown__select
            {
                min-width:unset;
                width:200px;
                height:32px;
                font-size:12px;
                border-radius:5px;
                border-color:var(--input-border-color);
            }

        }
    }
    .tma_day_labels{
        .tma_header_days_labels>*
        {
           margin-top:0.35rem;
        }
        .tma_days_entries_action
        {
            display:flex;
            flex-direction:column;
            gap:0.5rem;
        }
        .tma_days_info{
            display:flex;
            flex-direction:column;
            gap:0.5rem;
            align-items:center;
            p.day-label{
                color:var(--label-text);
            }
            &.tma_header_total_label{
            p.date-label
            {
                visibility:hidden;
            }
            .base-NumberInput-root{
                pointer-events:none;
                input{
                    width:40px;
                    height:27px;
                    border-radius:5px;
                    position:relative;
                    left:0;
                    padding:5px;
                    text-align:center;
                    border:none;
                    top:15px;
                }
            }
            }
            p.tma_row_count_label{
                top: 8px;
                position: relative;
                text-align: center;
            }
        }
         .base-NumberInput-root
        {
            input{
                width:40px;
                height:27px;
                border-radius:5px;
                position:relative;
                left:0;
                padding:5px;
                text-align:end;
                border:1px solid var(--input-border-color);
            }
            input:disabled{
                background-color:var(--input-disabled-color);
                border-color:var(--input-disabled-color);
            }
            &.tma_holiday_input
            {
                input{
                    border:1px solid var(--holiday-indicator);
                }
                input:disabled{
                    background-color:var(--input-disabled-color);
                    border-color:var(--holiday-indicator);
                }
            }
        }
    }
}

section.tma_time_entry_container.tma_time_entry_container_read
{
   .tma_drpdwn-row .tma__dropdown__select{
    border:none;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    svg.MuiSvgIcon-root{
        display:none;
    }
   }
    .tma_task_headers .task_headers_item_labels{
        margin-left:0;
        .tma_drpdwn_action_row label span.tma_label_required {
            display:none;
        }
    }
    .tma_days_entries_action{
        .tma_input_entry{
                input.base-NumberInput-input
                {
                    background-color: transparent;
                    border: none;
                    font-weight: bold;
                    text-align: center;
                }
                input.base-NumberInput-input::after{
                    content:"h"
                }
            }
        }
    }
}
`;
export const StyledCreateTimesheetContainer = styled.section`
padding-bottom:1rem;
header.tma_timesheet_header
{
    .tma_primary_row{
        h1{
            font-size:24px;
        }
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .tma_submit_actions{
            display:flex;
            gap:0.45rem;
            align-items:center;
            flex-wrap: wrap;
            button{
                border-radius:5px;
            }
            .week-picker-display
            {
                box-shadow: none;
                border: 1px solid #ddd;
                border-radius: 0;
                padding: 0;
                scale: none;
                height: 41px;
                div.selected-week-display {
                    margin: 0;
                    .arrow-container {
                        width: 40px;
                        height: 40px;
                        border-radius: 0;
                        background: var(--primary-text);
                        svg {fill: #fff; stroke: #fff; width: 16px; height: 16px;}
                    }
                }
                    div.selected-week-indicator{gap: 0;}
            }
            }
            button.tma_popup_btn
            {
                background-color:var(--route-active-bg);
                color: var(--route-active-text);
                display: flex;
                align-items: center;
            }
                button {
                height: 40px;
                  &.tma_time_submit_btn {
                    background-color: var(--success)
                  }
                    &.tma_time_draft_btn {
                      border-color: var(--primary-text);
                      color: var(--primary-text);
                      &:hover {
                        background-color: var(--primary-text);
                        color: white;
                      }
                    }
                }
        }
    }
    .tma_secondary_row{
        display: flex;
        justify-content: end;
        margin-top: 1rem;
        .tma_submit_actions
        {
            display: flex;
            gap: 1rem;
            align-items: center;
            button{
                height:34px;
            }
        }
    }
 &.tma__timsheet_approval_header{
   .tma_submit_actions{
    button.tma_time_reject_btn, button.tma_time_arrove_btn{
        width:120px;
        span {margin: 0; &.tma_btn_text {padding-right: 5px;} &.tma_btn_custom_icon svg {width: 20px;}}
    }
    button.tma_time_arrove_btn {
        background-color: var(--success);
        transition: all 0.5s ease-in-out;
        &:hover {
          background-color: var(--success-hover);
        }
    }
   }
 }
}
section.tma_time_entry_container
{
    background-color: white;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 1rem;
    margin: 1rem auto;
    border-radius: 5px;
    position: relative;
    button.tima_time_editoff-button{
     position: absolute;
     top: 8px;
     right: 8px;
     background-color: transparent;
     border: none;
     padding: 0;
     font-weight: bold;
     cursor: pointer;
     color: var(--primary-button-bg);
     svg {
      fill: var(--primary-text);
     }
    }
    
}
section.tma_proj_details
{    
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .tma_prj_info_container
    {
        display:flex;
        flex-direction: column;
        p.tma_pnf_label
        {
            color:var(--label-text);
            flex: auto;
            max-width: initial;
        }
    }
    .tma_copy_previous
    {
        width:100%;
        margin-left:auto;
        button{
            text-transform:none;
            text-decoration:underline;
            font-size: 13px;
            padding-left: 0;
        }
    }
}
section.tma_time_entry
{
    font-size:12px;
    .form_card {
      &.timsheet-entry {
        overflow: auto;
        display: flex;
        align-items: flex-start;
        min-width: 1360px;
        padding: 1rem;
      }
      padding: 1.5rem 0.5rem 2.5rem 0.5rem
      margin-top: 1rem;
      background-color: #f5f5f5;
      border-radius: 5px;
      margin: 1rem;
      .tma_section-subtitle {
        color: var(--primary-text);
        font-size: 13px;
        background-color: #f5f5f5;
        padding: 0.5rem;
        border-bottom: 1px dashed #ddd;
        }
        .tma-form_field_content {
          padding: 1rem;
          &.no-padding {padding-bottom: 0;}
          input {background-color: white;}
        }
      
    }
    button.tma_add_new_row
    {
        height: 40px;
        margin-top: 1rem;
        text-transform:none;
        border-radius: 5px;
       
        background-color: var(--primary-text);

    }
    .tma_approver_cmnts{
        font-size:14px;
        margin:1rem auto;
        span.tma_label{
            color:var(--label-text);
        }
        span.tma_value{
            color:#333;
            font-weight:bold;
            margin-left:0.75rem;
        }
    }
    .tma_comment_box
    {
      margin: 1rem 0;
       input, div {
        width: 100%;
       } 
        input {
          // height: 100px;
        }
    }
    hr {
      width: 100%;
    }
    .tma_time_total_hours
    {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: 0 1rem;
          min-width: 1360px;
          width: calc(100% - 2rem);
          padding: 0 1rem;
          .tma_time_total_hours--first {
            flex-basis: 50%;
          }
          .tma_time_total_hours--second {
            flex-basis: 50%;
            
            
            .tma_col_count{
            display: flex;
            justify-content: space-between;
            gap: 0.5rem;
            width: auto;
            margin: 0 1rem;
            p, .count {
              width: 12.5%;
              font-size: 13.3px;
              font-weight: 400;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
        }
          }
          .tma_time_label {
          }
        .tma_col_count{
            display: flex;
            justify-content: space-around;
            p {
              width: 11%;
              font-size: 13.3px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
        }
    }
    .tma_timesheet_note{
        margin-left: auto;
        width: 27%;
        margin-top: 1.5rem;
        font-size: 12px;
    }
}
div.tma_entry_sheet_info
{
    overflow: auto;
    .tma_task_headers,.tma_day_labels
    {
        display:flex;
        gap: 0.5rem;
        width: 100%;
        justify-content: space-between;
    }
    .tma_task_headers{
        flex-direction:column;
        gap:0;
        width: 50%;
        
        .empty-row{
            visibility:hidden;
        }
        .task_headers_item_labels
        {
          display: flex;
              gap: 0;
              flex-wrap: wrap;
              width: calc(100% - 30px);
              justify-content: flex-end;
              align-items: flex-end;
              margin-left: 30px;
            .tma_drpdwn_action_row
            {
                text-align: center;
                flex-basis: auto;
                width: 33.3%;
                label{
                white-space: nowrap;
                font-size: 13px;
                color:var(--label-text);
                span.tma_label_required
                {
                    color:red;
                    margin-left:0.25rem;
                }
            }
            }
        }
        .tma_prj_action_items
        {
            display:flex;
            flex-direction: column;
            margin-top:0.10rem;
        }
        .tma_task_prj_lables{
            display:flex;
            gap:1rem;
        }
        .tma_drpdwn-row {
            display: flex;
            gap: 0.5rem;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-top: 1rem;
            &:first-child {
              padding: 0;
            }
              // @media (max-width: 680px) {
              //   flex-direction: column;
              // }
            .tma_drpdwn_action_row {
              width: 30%;
              display: flex;
              flex-direction: column;
              &.withLabels {
                label {
                  font-size: 12px;
                  margin: 0;
                }
              }
              // @media (max-width: 680px) {
              //   width: 100%;
              // }
            }
            label{
                span.tma_label_required
                {
                    color:red;
                    margin-left:0.25rem;
                }
            }
            .tma_delete_row
            {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                svg{
                    width:20px;
                    cursor:pointer;
                }
            }
            .tma__dropdown__select
            {
                min-width:unset;
                width: 100%;
                height: 40px;
                font-size: 13px;
                border-radius: 5px;
                border-color: #ddd;
            }

        }
    }
        .tma_day_labels--overflow {
          width: 50%;
          // @media (max-width: 1660px) {
          //   width: 680px;
          // }
        }
    .tma_day_labels{
        margin:0 1rem;
        width: auto;
        @media (max-width: 680px) {
          margin: 1rem 0;
          min-width: 480px;
        }
        .tma_header_days_labels>*
        {
           margin-top:0.35rem;
        }
        .tma_days_entries_action
        {
            display:flex;
            flex-direction:column;
            gap:1rem;
        }
        .tma_days_info{
            display:flex;
            flex-direction:column;
            gap:0.5rem;
            align-items:center;
            width: 12.5%;
            .tma_header_days_labels {
                width: 100%;
                text-align: center;
                p {margin: 0;}
            }
            p.day-label{
                color:var(--label-text);
            }
            &.tma_header_total_label{
            p.date-label
            {
                visibility:hidden;
            }
            .base-NumberInput-root{
                pointer-events:none;
                input{
                    width: 100%;
                    height: 40px;
                    border-radius:5px;
                    position:relative;
                    left:0;
                    padding:5px;
                    text-align:center;
                    border:none;
                    top:15px;
                    border-color: #ddd;
                }
            }
            }
            p.tma_row_count_label{
                top: 8px;
                position: relative;
                text-align: center;
            }
        }
         .base-NumberInput-root
        {
            button {display: none;}
            input{
                width:40px;
                height:27px;
                border-radius:5px;
                position:relative;
                left:0;
                padding:5px;
                text-align:end;
                border:1px solid var(--input-border-color);
            }
            input:disabled{
                background-color:var(--input-disabled-color);
                border-color:var(--input-disabled-color);
            }
            &.tma_holiday_input
            {
                input{
                    border:1px solid var(--holiday-indicator);
                }
                input:disabled{
                    background-color:var(--input-disabled-color);
                    border-color:var(--holiday-indicator);
                }
            }
        }
    }
}
div.tma_entry_sheet_info .tma_day_labels .base-NumberInput-root input {
  width: 100%;
  border-color: #ddd;
  height: 40px;
  text-align: center;
}
section.tma_time_entry_container.tma_time_entry_container_read
{
   .tma_drpdwn-row .tma__dropdown__select{
    border:none;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    svg.MuiSvgIcon-root{
        display:none;
    }
   }
    .tma_task_headers .task_headers_item_labels{
        margin-left:0;
        .tma_drpdwn_action_row label span.tma_label_required {
            display:none;
        }
    }
    .tma_days_entries_action{
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        width: 100%;
        justify-content: center;
        align-items: center;
        
        .tma_input_entry{
        input.base-NumberInput-input {
              width: 100% !important;
              height: 40px !important;
              border: 1px solid #ddd !important;
        }
                input.base-NumberInput-input
                {
                    background-color: transparent;
                    border: none;
                    font-weight: bold;
                    text-align: center;
                }
                input.base-NumberInput-input::after{
                    content:"h"
                }
            }
        }
    }
}
`;
export const StyledTimesheetViewMode = styled.section`
  width: 100%;
  margin-top: 1rem;
  border: 0px solid var(--input-border-color);
  border-radius: 5px;
  padding: 0rem;
  position: relative;
  button.tima_time_edit-button {
    position: absolute;
    top: 50px;
    right: 0;
    background-color: transparent;
    border: none;
    padding: 1rem;
    font-weight: bold;
    cursor: pointer;
    color: var(--primary-text);
    @media (max-width: 640px) {
      top: 104px;
      right: -10px;
    }
  }
  .tma_timesheet_table {
    // height: 150px;
    // @media (max-width: 767px) {
    //   height: 160px;
    // }
    // max-height: calc(100vh - 255px);
    .ag-theme-material {
      .ag-theme-checkboxStyle-1.ag-theme-iconSet-2.ag-theme-tabStyle-3.ag-theme-inputStyle-4 {
        overflow-x: auto;
        border: 1px solid #ddd;
        border-radius: 3px;
        .ag-center-cols-viewport {
          div[role="row"]:last-child {
            border: 0;
          }
        }
        .ag-root-wrapper.ag-ltr.ag-layout-normal {
          min-height: 300px;
          max-height: calc(100vh - 295px);
          @media (max-width: 767px) {
            min-width: 980px;
          }
          border: none;
          border-radius: 0px;
          .ag-header-cell {
            &:last-child {
              .ag-header-cell-resize {
                &:after {
                  display: none;
                }
              }
            }
          }
        }
      }
      .ag-center-cols-viewport {
        .ag-cell {
          font-size: 13px;
        }
        .ag-center-cols-container {
          .ag-row-no-focus.ag-row {
            &:nth-child(2n + 1) {
              background-color: #f5f5f5;
            }
          }
        }
      }
      .MuiTablePagination-root {
        .MuiToolbar-root {
          padding: 0 !important;
        }
      }
    }
  }
  .ag-header-cell-label {
    font-size: 13px;
    font-weight: 500;
  }
  .ag-header-cell {
    &:last-child {
      .ag-header-cell-resize {
        &:after {
          display: none;
        }
      }
    }
  }

  .ag-header-cell-comp-wrapper {
    justify-content: center;
  }
  .ag-cell,
  .ag-custom-header-cell {
    font-size: 13px;
    font-weight: 400 !important;
  }
  .ag-custom-header-cell {
    gap: 0rem;
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  section.tma_proj_details {
    padding: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 14px;
    border-radius: 5px;
    margin-bottom: 0.25rem;
    .tma_prj_info_container {
      display: flex;
      width: auto;
      margin-top: 0.5rem;
      flex-direction: column;
      gap: 0.5rem;
      p.tma_pnf_label {
        flex: 0;
        color: var(--primary-text);
        font-weight: 500;
      }
      .tma_pnf_value {
        font-size: 13px;
        color: #555;
      }
      .file_download {
        color: #0766d4 !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .file_download:hover {
        text-decoration: underline;
        cursor: pointer;
      }
      @media (max-width: 640px) {
        width: 50%;
        &:nth-child(2n + 2) {
          align-items: flex-end;
        }
      }
    }
  }
  .tma_approver_section {
    padding: 0.5rem;
    .tma_prj_info_container {
      display: flex;
      width: 40%;
      margin: 0.25rem 0 0.5rem;
      gap: 0.5rem;
      p.tma_pnf_label {
        color: var(--label-text);
      }
    }
  }
`;

export const StyledApprovalModal = styled.div`
  h1.tma_modal_title {
    font-size: 18px;
    text-transform: uppercase;
  }
  .tma_modal_actions {
    display: flex;
    justify-content: end;
    margin-top: 0.5rem;
    gap: 0.5rem;
    .tma_app_btn.tma_cancel_btn.primary-outline {
      border-color: #e2040e;
      color: #e2040e;
      transition: all 0.5s ease-in-out;
      &:hover {
        background-color: #e2040e;
        color: white;
      }
    }
    .tma_app_btn.tma_confirm_btn {
      background-color: var(--primary-text);
      transition: all 0.5s ease-in-out;
      &:hover {
        background-color: var(--primary-text-hover);
      }
    }
  }
  .tma_approver_comment_section {
    margin-top: 0.5rem;
    textarea {
      border: 1px solid #ddd;
      resize: none;
      border-radius: 5px;
      padding: 0.5rem;
      margin-top: 0.5rem;
      max-width: 100%;
      width: 100%;
    }
  }
  p.tma_modal_info {
    font-size: 14px;
    width: 100%;
    margin-top: 0.5rem;
  }
`;
